// extracted by mini-css-extract-plugin
export default {"Skeleton":"EMNm_K8I","shimmer":"nWXUVMXv"};